import React, { useEffect, useState } from "react";

import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";
import GroupSegregationSection from "./GroupSegregationSection";

export default function UploadInput({
  deleteComponent,
  rowId,
  colId,
  attributes,
  setAttributes,
  autoOpen = false,
  groups = [],
}) {
  const [label, setLabel] = useState(
    attributes ? attributes.label : "Texto do Upload",
  );
  const [placeholder, setPlaceholder] = useState(
    attributes ? attributes.placeholder : "Texto do Placeholder",
  );
  const [tipText, setTipText] = useState(
    attributes ? attributes.tipText : "Texto da Dica",
  );
  // Segregação por grupos — se `groupIds` tiver itens, o campo só é
  // visível pros participantes desses grupos.
  const [groupIds, setGroupIds] = useState(attributes?.groupIds || []);
  const [hasTip, setHasTip] = useState(attributes ? attributes.hasTip : false);
  const [required, setRequired] = useState(
    attributes ? attributes.required : false,
  );

  // Edit Modal
  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    if (autoOpen) setEditModal(true);
  }, []);

  const submitForm = (e) => {
    e.preventDefault();

    setAttributes({
      rowId,
      colId,
      attributes: {
        inputName: label,
        label,
        placeholder,
        tipText,
        hasTip,
        required,
        ...(groupIds.length > 0 ? { groupIds } : {}),
      },
    });
    setEditModal(false);
  };

  return (
    <div className="custom-input-container" id="updload-component">
      <Modal
        size="lg"
        isOpen={editModal}
        toggle={() => setEditModal(!editModal)}
        centered
      >
        <ModalHeader toggle={() => setEditModal(false)}>
          Configurar Input
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <Form>
                <FormGroup className="input-margin-btm">
                  <Label htmlFor="edit-input-text" className="form-label">
                    Nome do Campo
                  </Label>
                  <Input
                    id="edit-input-text"
                    className="form-control"
                    type="text"
                    value={label}
                    onChange={({ target }) => setLabel(target.value)}
                  />
                </FormGroup>
                <FormGroup className="input-margin-btm">
                  <Label
                    htmlFor="edit-input-placeholder"
                    className="form-label"
                  >
                    Texto do placeholder
                  </Label>
                  <Input
                    id="edit-input-placeholder"
                    className="form-control"
                    type="text"
                    value={placeholder}
                    onChange={({ target }) => setPlaceholder(target.value)}
                  />
                </FormGroup>
                <FormGroup className="input-margin-btm">
                  <Input
                    className="input-mg-rgt"
                    id="edit-input-has-tip"
                    type="checkbox"
                    checked={hasTip}
                    onChange={({ target }) => setHasTip(target.checked)}
                  />
                  <Label htmlFor="edit-input-has-tip" className="form-label">
                    Possui dica?
                  </Label>
                  {hasTip && (
                    <FormGroup className="input-margin-btm">
                      <Label htmlFor="edit-input-tip" className="form-label">
                        Texto da dica
                      </Label>
                      <Input
                        id="edit-input-tip"
                        className="form-control"
                        type="text"
                        value={tipText}
                        onChange={({ target }) => setTipText(target.value)}
                      />
                    </FormGroup>
                  )}
                </FormGroup>
                <FormGroup className="input-margin-btm">
                  <Input
                    className="input-mg-rgt"
                    id="edit-input-required"
                    type="checkbox"
                    checked={required}
                    onChange={({ target }) => setRequired(target.checked)}
                  />
                  <Label htmlFor="edit-input-required" className="form-label">
                    Campo obrigatório?
                  </Label>
                </FormGroup>
              </Form>
              <GroupSegregationSection
                groups={groups}
                groupIds={groupIds}
                onChange={setGroupIds}
                fieldPrefix={`uploadinput-${rowId}-${colId}`}
              />
            </Col>
            <Col style={{ borderLeft: "1px solid gray" }}>
              <div style={{ display: "flex" }}>
                <Label className="form-label" htmlFor="formText">
                  {label === "Texto do Upload" ? (
                    label
                  ) : (
                    <div dangerouslySetInnerHTML={{ __html: label }} />
                  )}
                </Label>
                {required && <span> *</span>}
                {hasTip && (
                  <div>
                    <div
                      className="show-tips"
                      id={`upload-tip-${rowId}-${colId}`}
                    >
                      <span>?</span>
                    </div>
                    <UncontrolledTooltip
                      style={{ backgroundColor: "#6f42c1" }}
                      placement="right"
                      target={`upload-tip-${rowId}-${colId}`}
                    >
                      {tipText}
                    </UncontrolledTooltip>
                  </div>
                )}
              </div>
              <Input
                className="form-control"
                type="text"
                id="formText"
                placeholder={placeholder}
              />
            </Col>
          </Row>

          <div className="save-btn-form-container">
            <Button
              color="success"
              className="btn btn-success waves-effect waves-light save-btn-form"
              onClick={submitForm}
            >
              Salvar
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <div>
        <div className="displayed-config-container">
          <div className="displayed-label">
            <Label className="form-label" htmlFor="formText">
              {label === "Texto do Upload" ? (
                label
              ) : (
                <div dangerouslySetInnerHTML={{ __html: label }} />
              )}
            </Label>
            {required && <span> *</span>}
            {hasTip && (
              <div>
                <div className="show-tips" id={`upload-tip-${rowId}-${colId}`}>
                  <span>?</span>
                </div>
                <UncontrolledTooltip
                  style={{ backgroundColor: "#6f42c1" }}
                  placement="right"
                  target={`upload-tip-${rowId}-${colId}`}
                >
                  {tipText}
                </UncontrolledTooltip>
              </div>
            )}
          </div>
          <div className="config-form-icon">
            <span
              className="mdi mdi-cog-outline"
              onClick={() => setEditModal(!editModal)}
            />
            <span
              className="mdi mdi-close close-icon"
              onClick={() => deleteComponent(rowId, colId)}
            />
          </div>
        </div>
      </div>
      <Input
        className="form-control"
        type="file"
        id="formFile"
        defaultValue={null}
      />
    </div>
  );
}
